import React, { lazy } from "react";

const LazyCorrectionsApprovalBatchDetails = lazy(
  () => import("./CorrectionsApprovalBatchDetails")
);

const CorrectionsApprovalBatchDetails = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode }
) => <LazyCorrectionsApprovalBatchDetails {...props} />;

export default CorrectionsApprovalBatchDetails;
